import { render, staticRenderFns } from "./ForumRules.vue?vue&type=template&id=34bc0cf0&scoped=true&"
import script from "./ForumRules.vue?vue&type=script&lang=js&"
export * from "./ForumRules.vue?vue&type=script&lang=js&"
import style0 from "./ForumRules.vue?vue&type=style&index=0&id=34bc0cf0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34bc0cf0",
  null
  
)

export default component.exports